<script>
import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: {
        chartLabels: {
            type: Array,
            default: () => []
        },
        chartData: {
            type: Array,
            default: () => []
        },
        width: {
            type: String,
            default: '100%'
        }
    },
    watch: {
        chartData() {
            this.render()
        }
    },
    mounted() {
        this.render()
    },
    methods: {
        render() {
            this.renderChart({
                labels: this.chartLabels,
                datasets: [{
                    label: 'Envíos',
                    data: this.chartData,
                    borderColor: '#556EE6',
                    backgroundColor: 'rgba(85, 110, 230, 0.1)',
                    borderWidth: 2.5,
                    pointBackgroundColor: '#556EE6',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointRadius: 5,
                    pointHoverRadius: 7,
                    fill: true,
                    tension: 0.4
                }]
            }, {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            fontSize: 12,
                            fontColor: '#999'
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            borderDash: [4, 4],
                            color: '#eee'
                        },
                        ticks: {
                            fontSize: 12,
                            fontColor: '#999',
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                tooltips: {
                    backgroundColor: '#333',
                    titleFontSize: 12,
                    bodyFontSize: 13,
                    callbacks: {
                        label: (tooltipItem) => {
                            return ` ${tooltipItem.yLabel} envíos`;
                        }
                    }
                }
            })
        }
    }
}
</script>
